/**
 * Numeric IDs for payment modes as stored in the backend MST code list (PYMT_MODE).
 * Use these constants instead of raw numbers when comparing `paymentMode`.
 */
export enum PaymentMode {
  /** Standard bank transfer */
  BankTransfer = 1,
  /** Wallet payment */
  Wallet = 2,
  /** Alternate bank transfer variant (used in OPC / beneficiary flows) */
  BankTransferAlt = 3,
  /** Credit / prepaid credit */
  Credit = 4,
  /** PayCargo integration */
  PayCargo = 6,
  /** Online payment gateway (PayPal / card via payment-gateway-v2) */
  OnlineGateway = 7,
  /** Excluded / hidden mode (filtered out from selectable options) */
  Excluded = 8,
  /** Cheque payment */
  Cheque = 9,
  /** PAYPAL CREDIT AND DEBIT CARRRRRRRRRRRDS */
  PaypalCard = 10,
  /** Cash deposit / exchange */
  CashDeposit = 11,
  /** QR code payment */
  QRCode = 12,
  /** MTN Mobile Money via e-NKAP */
  MtnMobileMoney = 13,
  /** VAN (Virtual Account Number) payment — UI-only mode, not assigned by backend */
  VanPayment = 98,
}
